<!--  -->
<template>
  <div class="container">
    <div class="item one">
      <img class="phone" src="../../assets/image/phone@2x.png" alt />
      <input type="number" v-model="getPhoneNumber" placeholder="请输入新的手机号码" />
    </div>
    <div class="item">
      <img class="phone" src="../../assets/image/yanzheng@2x.png" alt />
      <input type="number" @input="changeCode" v-model="inputCode" placeholder="请输入验证码" />
      <button
        class="get_code"
        :style="{backgroundColor:bgColor}"
        @click="sendMsg"
        :disabled="disable"
      >{{getCode}}</button>
    </div>
    <button @click="enter" class="next">确认</button>
  </div>
</template>

<script>
import { Dialog } from 'vant';
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import { Base64 } from "js-base64"; //base64加密
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      getCode: "验证码",
      bgColor: "#2f85ed",
      disable:false,

      getPhoneNumber:"",
      inputCode:"",
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
     // 发送短信
    sendMsg() {
      let time = 60;
      if (this.getCode == "验证码") {
        this.$http
          .sendCode({
            phone: this.getPhoneNumber,
            type: 6
          })
          .then(res => {
            if (res.status == 1) {
              let interval = setInterval(() => {
                time--;
                this.getCode = time + "秒";
                this.bgColor = "#86c3fb";
                if (time <= 0) {
                  clearInterval(interval);
                  this.getCode = "验证码";
                } else {
                  this.bgColor = "#86c3fb";
                }
              }, 1000);
            }else{
              this.$hide.alert({
                message:res.msg
              })
            }
          });
      }
    },
    // 解决复制两次验证码的问题
    changeCode(){
      //解决复制两次
      if(this.inputCode.length>=5){
        this.inputCode=this.inputCode.slice(0,4)
      }
    },
    // 确认
    enter(){
      Dialog.confirm({
        title:"提示",
        message:"确定要修改手机号码吗?"
      }).then(()=>{
        this.$http.studentModifyPhone({
        phone:this.getPhoneNumber,
        code:this.inputCode
      }).then(res=>{
        if(res.status == 1){
          this.$toast({
            message:res.msg,
            onOpened:()=>{
              setTimeout(() => {
                localStorage.removeItem('token')
                this.$router.push({path:'/login'})
              }, 3000);
              
            }
          })
        }else{
          this.$toast(res.msg)
        }
      })
      })
      
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  width: 100%;
  height: 100vh;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #fff;
  overflow: hidden;
  .one {
    margin-top: 51px;
  }
  .item {
    width: 100%;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 10px;
    padding-bottom: 10px;
    box-sizing: border-box;
    .phone {
      width: 14px;
      height: 16px;
      vertical-align: middle;
    }
    input {
      border: none;
      height: 30px;
      font-size: 15px;
      margin-left: 15px;
      line-height: 30px;
      width: 50%;
    }
    
    .get_code {
      width: 90px;
      height: 30px;
      border-radius: 15px;
      border: none;
      // background-color: #2f85ed;
      font-size: 13px;
      color: #fff;
      float: right;
      line-height: 30px;
      margin-top: 10px;
    }
  }
  .pwdHint{
      margin-top: -5px;
      font-size: 15px;
      color: red;
      vertical-align: middle;
    }
  .next {
    width: 100%;
    height: 44px;
    background-color: #0e88f7;
    border: none;
    color: #ffffff;
    border-radius: 22px;
    margin-top: 40px;
    font-size: 17px;
    display: block;
    text-align: center;
    line-height: 44px;
  }
}
</style>